import { Caption, Heading, Stack } from '@mediahuis/chameleon-react';
import React, { FC, ReactNode } from 'react';

type RegistrationFlowHeaderProps = {
  title: ReactNode;
  subtitle: ReactNode;
  selector?: string;
};

export const RegistrationFlowHeader: FC<RegistrationFlowHeaderProps> = ({
  title,
  subtitle,
  selector,
}) => {
  return (
    <Stack data-cy={selector} className="px-6 m-auto text-center">
      <Heading as="h1" size="sm" className="mt-6 mb-3" id="container__registrationFlowHeaderText">
        {title}
      </Heading>
      <div className="mb-7">
        <Caption size="lg" className="paper__text--light">
          {subtitle}
        </Caption>
      </div>
    </Stack>
  );
};
